import React, { useEffect, useState } from "react";
import TablePagination from "@mui/material/TablePagination";
import { styled } from "@mui/material/styles";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell, { tableCellClasses } from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import Checkbox from "@mui/material/Checkbox";
import { Box, Stack } from "@mui/material";
import Button from "@mui/material/Button";
import IconButton from "@mui/material/IconButton";
import TextField from "@mui/material/TextField";
import { useDispatch, useSelector } from "react-redux";
import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import CloseIcon from "@mui/icons-material/Close";
import Typography from "@mui/material/Typography";
import SearchIcon from "@mui/icons-material/Search";
import {
  submitUserRoles,
  downloadUserRoles,
  getUserMaintanenceData,
} from "../Redux/UserMaintanence";
import UserAccessTable from './UserAccessTable';
import "./MaintanenceTable.css";

const BootstrapDialog = styled(Dialog)(({ theme }) => ({
  "& .MuiDialogContent-root": {
    padding: theme.spacing(5),
    paddingLeft: theme.spacing(15),
    paddingRight: theme.spacing(13),
  },
  "& .MuiDialogActions-root": {
    padding: theme.spacing(1),
  },
}));

const CssTextField = styled(TextField)({
  "& .MuiOutlinedInput-root": {
    // borderRadius: "50px",
    // borderColor: "7500c0",
    border: "0px",
    "&:hover fieldset": {
      // borderColor: "#7500c0",
    },
    "&.Mui-focused fieldset": {
      // borderColor: "#7500c0",
    },
  },
});

function MaintanenceTable({ isAlertSec, setisAlertSec}) {
  const trackDetails= useSelector((state)=>state?.track?.data);
  const [searchVal, setSearchVal] = useState("");  
  const [page, setPage] = useState(0);  
  const [rowsPerPage, setRowsPerPage] = useState(15);
  const [boolChecked, setBoolChecked] = useState(false);    
  const [filteredData, setFilteredData] = useState([]);
  const [checkedValues, setCheckedValues] = useState([]);

  const dispatch = useDispatch();           
  const userData = useSelector((state) => state.userRoles.UserMaintanenceData);  

  useEffect(() => {
    setFilteredData(userData);
  }, [userData]);

  const searchFunction = (e) => {
    setSearchVal(e.target.value);
  };

  const handleClose = () => {
    setisAlertSec(false);
  };    

  const handleSubmitClick = () => {
    const mappedArray = checkedValues.map((item) => {
      const mappedItem = {};
      for (const key in item) {
        if (key !== "Enterprise_ID") {
          mappedItem[key] = item[key] ? "yes" : "No";
        } else {
          mappedItem[key] = item[key];
        }
      }
      return mappedItem;
    });
    const changedObjects = mappedArray.filter(
      (obj2, index) =>
        !Object.keys(obj2).every(
          (key) => key === "sno" || obj2[key] === userData[index][key]
        )
    );    
    dispatch(submitUserRoles(changedObjects));
    setSearchVal("");    
    setisAlertSec(true);
  };

  useEffect(() => {
    dispatch(getUserMaintanenceData());
    setBoolChecked(false);
    setFilteredData(userData);
  }, [isAlertSec, boolChecked]);    

  useEffect(() => {    
    setCheckedValues(filteredData)              
  }, [filteredData, page]);



  useEffect(() => {    
    setFilteredData(
      userData?.filter((item) =>
        Object.keys(item).some((key) =>
          item["Enterprise_ID"].toLowerCase().includes(searchVal.toLowerCase())
        )
      )
    );    
  }, [searchVal]);    

  const handleDownload = () => {
    dispatch(downloadUserRoles());
  };
  const ColorButton = styled(Button)(({ theme }) => ({
    color: theme.palette.getContrastText("#7500C0"),
    backgroundColor: "#7500C0",
    marginLeft: "5%",
    "&:hover": {
      backgroundColor: "#7500C0",
      color: "#fff",
    },
  }));

  return (
    <Stack
      sx={{        
        width: "100%",
        margin: "auto",
        marginTop: "3%",
      }}
    >        
      <Box
        justifyContent={"start"}
        className="text-filed-box"
        display="flex"
        alignItems={"end"}
      >        
        <TextField
        variant="standard"
          placeholder="Search by Enterprise ID..."
          id="outlined-start-adornment"
          sx={{ m: 1, width: "25ch", align: "center" }}
          value={searchVal}
          onChange={searchFunction}
          size="small"
          margin="dense"
          InputProps={{
            endAdornment: (
              <IconButton type="submit" sx={{ p: "10px" }} aria-label="search">
                <SearchIcon />
              </IconButton>
            ),
          }}
        />
      </Box>
        
      <UserAccessTable filteredData={filteredData} trackDetails={trackDetails}/>

      {/* <div style={{ margin: "10px 0" }}>
        <Stack justifyContent={"center"} spacing={2} direction={"row"}>
          <ColorButton
            variant="contained"
            size="small"
            // autoFocus
            onClick={handleSubmitClick}
            sx={{
              "background-color": "white",
              "color": "black",
              "border": "2px solid blueviolet",
              "border-radius": "18px",
              "text-transform": "capitalize",
              "padding": "5px 29px",
              "font-weight": "600",
              "font-size": "14px"
            }}
          >
            Save
          </ColorButton>
          <ColorButton
            variant="contained"
            size="small"
            // autoFocus
            onClick={handleDownload}
          >
            Download
          </ColorButton>
        </Stack>
      </div> */}

      <BootstrapDialog
        onClose={handleClose}
        aria-labelledby="customized-dialog-title"
        open={isAlertSec}
      >
        <IconButton
          aria-label="close"
          onClick={handleClose}
          sx={{
            position: "absolute",
            right: 8,
            top: 8,
            color: (theme) => theme.palette.grey[500],
          }}
        >
          <CloseIcon />
        </IconButton>
        <DialogContent>
          <Typography gutterBottom style={{ marginTop: "50px" }}>
            {/* The role has been updated. */}
            Your changes are saved
          </Typography>
        </DialogContent>
        <DialogActions>
          <ColorButton
            variant="contained"
            className="cancel-button"
            size="small"
            sx={{
              background: "white",
              color: "#7500C0",
              border: "solid 1px #7500C0",
              marginRight: "40%",
            }}
            autoFocus
            onClick={handleClose}
          >
            Ok
          </ColorButton>
          {/* <Button autoFocus onClick={handleClose}>
            Close
          </Button> */}
        </DialogActions>
      </BootstrapDialog>      
    </Stack>
  );
}

export default MaintanenceTable;
